module.exports = __webpack_public_path__ + "img/bth_bed2_left_yaobu_sel.7f89ae53.png";